import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RefreshService {
    public eventsSubject = new Subject<void>();
    public refreshTime = new Subject<string>();
    public pageTitle = new Subject<string>();

    constructor() {}

    emitEvent(): void {
        this.eventsSubject.next();
    }

    setRefreshTime(): void {
        //this.refreshTime.next(moment(new Date()).format('L LT'));
        this.refreshTime.next(moment(new Date()).format('L LTS'));
    }

    setPageTitle(name: string): void {
        this.pageTitle.next(name);
    }
}
